export default {
  methods: {
    cor(index) {
      switch (parseInt(index)) {
        case 0:
          return '#03a5ed'
          break

        case 1:
          return '#2652a3'
          break

        case 2:
          return '#3ee9ff'
          break

        case 3:
          return '#5b88da'
          break

        case 4:
          return '#0e7dae'
          break

        default:
          return '#03a5ed'
          break
      }
    },
  },
}
